<template>
  <div class="table-responsive">
    <table id="table_list" class="table table-striped table-bordered table-hover dataTables-example">
      <thead>
      <tr>
        <th>ID</th>
        <th>Data Cadastro</th>
        <th>Descrição</th>
        <th>Documento</th>
        <th>Usuário</th>
        <th class="text-center">+</th>
      </tr>
      </thead>

      <tbody v-if="dados.length" class="overflow-auto" style="max-height: 300px">
        <tr v-for="documento in dados" :key="documento.id" :id="'linha_' + documento.key">
          <td class="text-right">{{ documento.id }}</td>
          <td>{{ documento.data_cadastro }}</td>
          <td>{{ documento.descricao }}</td>
          <td class="text-center"><a :href="documento.documento" class="btn btn-success fa fa-download" target="_blank"></a></td>
          <td>{{ documento.usuario }}</td>
          <td class="text-center"><i class="btn btn-danger btn-sm fa fa-trash"
                                     @click="deletarDados(documento.key, documento.id, documento.descricao)"></i></td>
        </tr>
      </tbody>

      <tbody v-else>
        <tr>
          <td :colspan="6" class="text-center">Não existe documentos no momento</td>
        </tr>
      </tbody>
    </table>
  </div>
  <br>
  <hr>
  <div class="float-right">
    <button type="submit" class="btn btn-primary font-bold" @click="abrirModal()">Adicionar Documento</button>
  </div>
  <button class="btn btn-success font-bold" @click="$emit('fechar')">
    Fechar
  </button>

  <BaseDocCadastro
      v-if="exibirModal"
      :origemId="itemKey"
      :origemApp="'ANALISES'"
      @fecharSubModal="exibirModal = false"
      @atualizarListaDoc="atualizarDoc"
  />
</template>

<script>
import BaseDocCadastro from '@/components/base/BaseDocCadastro.vue';
import {apiRequest, alertDelete} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes"

export default {
  name: 'DocumentosAnalise',
  props: {
    itemKey: String,
  },
  components: {
    BaseDocCadastro,
  },
  data() {
    return {
      dados: [],
      erro: null,
      docSelect: null,
      exibirModal: false
    }
  },
  emits: ['fechar'],
  methods: {
    atualizarDoc(novoDoc) {
      if (Array.isArray(novoDoc)){
        this.dados.push(...novoDoc);
      } else {
        this.dados.push(novoDoc);
      }
    },
    abrirModal() {
      this.exibirModal = true
    },
    deletarDados(docKey, docId, docDescricao) {
      let url = apiUrl.documentos.destroy(docKey);
      alertDelete(docKey,url, 'Você deseja deletar o registro?', `ID: ${docId} | ${docDescricao}`);
    },
    async getDados() {
      const resultado = await apiRequest("GET", apiUrl.documentos.list(this.itemKey));
      if (resultado.success) {
        this.dados = resultado.data.data;
      }
    },
  },
  mounted() {
    this.getDados();
  },
}
</script>
